/**
 * Agrege les verdicts des regles de design.
 * Les seuils des regles obligatoires determinent la reussite,
 * puis les contraintes et bonus determinent les etoiles.
 */
import { TGDTier, TGraphicDesignLessonConfig } from '../../../models/courses/graphicDesign';
import { evaluateRule, TGDFacts } from './rules';

export interface TGDRuleResult { ruleId: string; tier: TGDTier; passed: boolean; measured?: string }
export interface TGDEvaluation {
  results: TGDRuleResult[];
  requiredPassed: number;
  requiredTotal: number;
  requiredThreshold: number;
  requiredMet: boolean;
  constraintsMet: boolean;
  bonusMet: boolean;
  stars: 0 | 1 | 2 | 3;
}
export type { TGDFacts, TGDAnswers } from './rules';

/** Retourne les verdicts ordonnes et les etoiles sans modifier les faits. */
export const evaluate = (
  config: Pick<TGraphicDesignLessonConfig, 'rules' | 'requiredRules'>, facts: TGDFacts
): TGDEvaluation => {
  const rules = Array.isArray(config?.rules) ? config.rules : [];
  const results = rules.map(rule => {
    const outcome = evaluateRule(rule, facts);
    return {
      ruleId: typeof rule?.id === 'string' ? rule.id : '',
      tier: rule?.tier,
      ...outcome,
    };
  });
  const required = results.filter(result => result.tier === 'required');
  const requiredTotal = required.length;
  const requiredPassed = required.filter(result => result.passed).length;
  const requested = Number.isFinite(config?.requiredRules) ? config.requiredRules : 0;
  const requiredThreshold = requiredTotal === 0 ? 0
    : Math.max(1, Math.min(requiredTotal, requested <= 0 ? requiredTotal : requested));
  // Une creation libre sans regle obligatoire est gagnee des le depart.
  const requiredMet = requiredPassed >= requiredThreshold;
  const constraintsMet = results.filter(result => result.tier === 'constraint')
    .every(result => result.passed);
  const bonusMet = results.filter(result => result.tier === 'bonus')
    .every(result => result.passed);
  const stars: 0 | 1 | 2 | 3 = !requiredMet ? 0 : !constraintsMet ? 1 : !bonusMet ? 2 : 3;
  return {
    results, requiredPassed, requiredTotal, requiredThreshold,
    requiredMet, constraintsMet, bonusMet, stars,
  };
};
